export default __webpack_public_path__ + "static/media/Youtube.d0c10bc8.svg";